import { DemoProvider } from "./demo-provider";
import type { DataProvider } from "./provider";
import { SupabaseProvider } from "./supabase-provider";

export function createProvider(mode: string | undefined = import.meta.env.VITE_DATA_MODE): DataProvider {
  if (mode === "supabase") return new SupabaseProvider();
  // "serverless" demos a broker that forgets blocked devices' credentials (new secret on unblock).
  return new DemoProvider(undefined, { unrevokeIssuesSecret: import.meta.env.VITE_DEMO_BROKER === "serverless" });
}

export type { DataProvider, LiveFeedStatus, LiveWatch, Member } from "./provider";
export { DataError } from "./provider";
export type { EventReportQuery, ReportExportEntry, ReportQuery, RouteQuery } from "./reports";
